import { Navigate, useLocation } from 'react-router-dom';
import { useAbility } from '@/ability/AbilityProvider';

// Usage:
// <RequireAbility can={[['read', 'Dashboard']]} fallback="/not-authorized">
//     <YourPage />
// </RequireAbility>
//
// Rules:
// - can: array of tuples [action, subject]. Any tuple passing = access granted.
//   e.g. can={[['read', 'Leads'], ['manage', 'all']]}
// - Department isolation is automatically enforced by the ability builder
// - Admin roles bypass department checks

const RequireAbility = ({ can = [], children, fallback = '/not-authorized' }) => {
    const ability = useAbility();
    const loc = useLocation();

    const isAllowed = Array.isArray(can) && can.length > 0
        ? can.some(([action, subject]) => ability?.can(action, subject))
        : true; // no rules means public

    if (!isAllowed) {
        return <Navigate to={fallback} state={{ from: loc }} replace />;
    }

    return children;
};

export default RequireAbility;